import captionService from "CaptionService";
import type { CaptionRecord } from "./types";

export const lookup: CaptionRecord = {
  noResults: () => captionService.getString("1973c5e3-6b6c-4656-86b0-930284d0a348", "No records found"),
  showing: (formatParams) =>
    captionService.getString(
      "6f69d53c-3eae-48d7-af4e-6edc1b0393dc",
      "Showing 1 to {0} of {1} results",
      formatParams[0],
      formatParams[1],
    ),
  showMore: () => captionService.getString("a03f19f6-f47b-4356-a9e8-a6062d0b1006", "Show More"),
};
